"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, spacing, typography }) => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 12,
        alignItems: 'center',
    },
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: 'auto',
        height: 'auto',
        marginBottom: 4,
        marginRight: spacing(1),
        color: palette.icon.secondary,
    },
    personalDetails: {
        border: `1px solid ${palette.divider}`,
        padding: spacing(3),
        backgroundColor: palette.surface.default,
    },
    infoGroup: {
        '& span': {
            color: palette.text.primary,
        },
        marginBottom: spacing(2),
    },
    editButton: {
        textAlign: 'right',
    },
    subscriptionsDivider: {
        marginBottom: spacing(2),
        width: '50%',
    },
    statusCircle: {
        '&:before': {
            display: 'inline-block',
            content: '""',
            borderRadius: '50%',
            height: 8,
            width: 8,
            marginRight: 5,
        },
    },
    active: {
        '&:before': {
            backgroundColor: palette.success.main,
        },
    },
    inactive: {
        '&:before': {
            backgroundColor: palette.status.highMain,
        },
    },
    rectangle: {
        width: '367px',
        height: '145px',
        margin: '24p 16px 0 1px',
        padding: '10px 16px 0',
        borderRadius: '12px',
        backgroundColor: 'unset',
    },
    radioCheckbox: {
        marginBottom: 8,
    },
    totalChecking: {
        flexGrow: 0,
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        textAlign: 'left',
    },
});
exports.default = styles;
